// Module federation requires the entry file loading asynchronously, so we use this bootstrap file to load the main entry point
import { registerRemotes } from '@module-federation/enhanced/runtime'

declare global {
	interface Window {
		__APPERIO_REMOTE_URL__?: string
		__APPERIO_CONFIG__?: {
			topNavHeight?: number
		}
	}
}

// Register dynamic remote URL with the configured value from the server at runtime.
// this runtime remote URL was built from `apperio.baseUrl` in the server config.
const runtimeRemoteUrl = window.__APPERIO_REMOTE_URL__
if (runtimeRemoteUrl) {
	// Set the topNavHeight in the global config object,
	// This help the Apperio embedded pages to adjust their layout based on the height of the top navigation bar in the host application.
	window.__APPERIO_CONFIG__ = {
		topNavHeight: 64,
	}

	registerRemotes(
		[{ name: 'apperioRemote', entry: `${runtimeRemoteUrl}/mf-manifest.json?v=${Date.now()}` }],
		// force update the remote URL for the apperioRemote to ensure it uses the runtime value instead of the build time value.
		{ force: true },
	)
}

import('./main.jsx')
